<template>
    <div class="field">
        <div class="field__col" @click="focusInput">
            <input
                    class="field__input"
                    ref="input"
                    type="number"
                    :min="min"
                    :max="max"
                    :step="step"
                    :value="currentValue"
                    @input="inputHandler"
                    @blur="keyDownHandler"
                    @keydown.esc="keyDownHandler"
                    @keydown.enter="keyDownHandler"
                    @keydown.up.prevent="increment"
                    @keydown.down.prevent="decrement"

            />
            <span class="field__distance">km</span>
        </div>
        <div class="field__col">
            <button class="controls__btn controls__increment" :disabled="incrementDisabled" @click="increment"></button>
            <button class="controls__btn controls__decrement" :disabled="decrementDisabled" @click="decrement"></button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: Boolean,
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            },
            value: {
                required: true,
                type: Number
            },
            step: {
                type: Number,
                default: 1
            },
        },

        data() {
            return {
                currentValue: this.value,
                decrementDisabled: false,
                incrementDisabled: false,
                inputDisabled: false,
            }
        },

        watch: {
            value(val) {
                this.currentValue = val
            }
        },

        methods: {
            inputHandler(ev){
                let {valueAsNumber} = ev.target
                this._updateValue(valueAsNumber)
            },
            keyDownHandler() {
//                this.currentValue = this.value
            },

            increment() {
                if (this.disabled || this.incrementDisabled) {
                    return
                }

                let newVal = this.currentValue + 1 * this.step
                this.decrementDisabled = false

                this._updateValue(newVal)
            },
            decrement() {
                if (this.disabled || this.decrementDisabled) {
                    return
                }

                let newVal = this.currentValue + -1 * this.step
                this.incrementDisabled = false

                this._updateValue(newVal)
            },
            _updateValue(newVal) {
                const oldVal = this.currentValue;
                if (oldVal === newVal || typeof this.value !== 'number') {
                    return
                }
                if (newVal <= this.min) {
                    newVal = this.min
                    this.decrementDisabled = true
                }
                if (newVal >= this.max) {
                    newVal = this.max
                    this.incrementDisabled = true
                }
                this.currentValue = newVal

                this.$emit('updateRadius', this.currentValue)
            },
            focusInput() {
                this.$refs.input.focus()
            }

    },
    computed: {
      radius() {
          return `${this.currentValue} km`
      }
    },
    mounted() {
            if (this.value == this.min) {
                this.decrementDisabled = true
            }
            if(this.value == this.max) {
                this.incrementDisabled = true
            }
     }
    }
</script>

<style lang="sass" scoped>
.field
    display: flex
    padding: 5px 8px 5px 12px
    width: 120px
    &__col
        &:first-of-type
            display: flex
            flex: 1
            align-items: center
            justify-content: flex-start
    &__distance
        margin-left: 2px
    &__distance,
    &__input
        font-size: 14px
        +reg
        color: #01254E
    &__input
        width: 31%
        text-align: right
        +r(600)
            width: 6%
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
            -moz-appearance: textfield
.controls
    display: flex
    justify-content: flex-end
    align-items: center
    height: 22px
    &__btn + &__btn
        margin-top: 4px
    &__btn
        border: 1px solid rgba(#0B234B, 0.15)
        border-radius: 2px
        display: flex
        justify-content: center
        align-items: center
        width: 16px
        height: 13px
        color: #99A8B8
        outline: 0
        position: relative
        transition: border-color .3s ease, background .3s ease
        &:not([disabled])
            &:hover,
            &:focus
                background: #FCFDFF
                border-color: rgba(11, 35, 75, 0.25)
        &:disabled
            background: rgba(#FAFAFA, 0.5)
            &:before,
            &:after
                background: rgba( #0B234B, 0.15)
    &__increment,
    &__decrement
        &:before,
        &:after
            content: ''
            z-index: 1
            +vcenter
            background: $color--gray
            border-radius: 1.7px
            width: 8px
            height: 1.4px
            +tr(background .3s ease)
    &__increment
        &:after
            transform: translate(-50%, -50%) rotate(90deg)
    &__decrement
        &:after
            content: none


</style>

